export interface PreviewConfigInterface {
    mainJs: string;
    styleCss: string;
}

export const previewConfig: PreviewConfigInterface = {
    mainJs: '',
    styleCss: ''
};
